import React, { useMemo, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { FaEraser, FaSearch } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

// W-0551 — 14 tipos hardcoded conforme UBxChData.dfm RxTipo.Items (gate-1b Q-04)
export const TIPOS_TITULO_BAIXA = [
  { value: '0', label: 'Todos' },
  { value: '1', label: 'Cheque a Receber' },
  { value: '2', label: 'Duplicata a Receber' },
  { value: '3', label: 'Promissória a Receber' },
  { value: '4', label: 'Custódia Cheque a Receber' },
  { value: '5', label: 'Custódia Duplicata a Receber' },
  { value: 'C', label: 'Custódia Promissória a Receber' },
  { value: 'D', label: 'Boleto a Receber' },
  { value: '6', label: 'Cheque a Pagar' },
  { value: '7', label: 'Duplicata a Pagar' },
  { value: '8', label: 'Promissória a Pagar' },
  { value: 'E', label: 'Boleto a Pagar' },
  { value: '9', label: 'Custódia Cheque a Pagar' },
  { value: 'A', label: 'Custódia Duplicata a Pagar' },
];

const CAMPOS_BUSCA_RAPIDA = [
  { value: 'numero', label: 'Número' },
  { value: 'valor', label: 'Valor' },
  { value: 'vencimento', label: 'Vencimento' },
  { value: 'nosso_numero', label: 'Nosso Número' },
];

const toOption = (item, valueKey, labelKey, fallbackLabelKey) => ({
  value: item[valueKey],
  label: item[labelKey] || (fallbackLabelKey ? item[fallbackLabelKey] : '') || String(item[valueKey]),
});

const CardFiltros = ({
  filtros,
  onChange,
  onPesquisar,
  onLimpar,
  gruposEmpresa = [],
  bancos = [],
  portadores = [],
  cedentes = [],
  moedas = [],
  geAutoSelecionado = false,
}) => {
  const [colapsado, setColapsado] = useState(false);

  const gruposOptions = useMemo(
    () => gruposEmpresa.map((g) => toOption(g, 'codigo_grupo_empresa', 'apelido', 'descricao')),
    [gruposEmpresa],
  );
  const bancosOptions = useMemo(
    () => bancos.map((b) => toOption(b, 'codigo', 'descricao', 'apelido')),
    [bancos],
  );
  const portadoresOptions = useMemo(
    () => portadores.map((p) => toOption(p, 'codigo_conta', 'apelido_conta', 'apelido')),
    [portadores],
  );
  const cedentesOptions = useMemo(
    () => cedentes.map((c) => toOption(c, 'codigo_conta', 'apelido_conta', 'apelido')),
    [cedentes],
  );
  const moedasOptions = useMemo(
    () => moedas.map((m) => toOption(m, 'codigo', 'descricao', 'apelido')),
    [moedas],
  );

  const atualizar = (campo, valor) => {
    onChange({ ...filtros, [campo]: valor });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onPesquisar();
  };

  return (
    <div className="bg-white border rounded p-3 mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">Filtros</h5>
        <Button
          variant="link"
          size="sm"
          onClick={() => setColapsado((c) => !c)}
        >
          {colapsado ? 'Expandir' : 'Recolher'}
        </Button>
      </div>

      {!colapsado && (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col xs={12} md={4} lg={3}>
              <Form.Group>
                <Form.Label className="small mb-1">Grupo de Empresa *</Form.Label>
                <Select
                  isDisabled={geAutoSelecionado}
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={gruposOptions}
                  placeholder="Selecione..."
                  noOptionsMessage={() => 'Nenhum GE'}
                  value={gruposOptions.find((o) => o.value === filtros.codigoGrupoEmpresa) || null}
                  onChange={(opt) => atualizar('codigoGrupoEmpresa', opt ? opt.value : '')}
                />
              </Form.Group>
            </Col>
            <Col xs={6} md={4} lg={2}>
              <Form.Group>
                <Form.Label className="small mb-1">Vencimento de *</Form.Label>
                <Form.Control
                  type="date"
                  value={filtros.dataVencimentoIni}
                  onChange={(e) => atualizar('dataVencimentoIni', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={6} md={4} lg={2}>
              <Form.Group>
                <Form.Label className="small mb-1">Vencimento até *</Form.Label>
                <Form.Control
                  type="date"
                  value={filtros.dataVencimentoFim}
                  onChange={(e) => atualizar('dataVencimentoFim', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label className="small mb-1">Banco</Form.Label>
                <Select
                  isClearable
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={bancosOptions}
                  placeholder="Todos"
                  noOptionsMessage={() => 'Nenhum banco'}
                  value={bancosOptions.find((o) => o.value === filtros.codigoBanco) || null}
                  onChange={(opt) => atualizar('codigoBanco', opt ? opt.value : null)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6} lg={2}>
              <Form.Group>
                <Form.Label className="small mb-1">Moeda</Form.Label>
                <Select
                  isClearable
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={moedasOptions}
                  placeholder="Todas"
                  noOptionsMessage={() => 'Nenhuma moeda'}
                  value={moedasOptions.find((o) => o.value === filtros.codigoAtivo) || null}
                  onChange={(opt) => atualizar('codigoAtivo', opt ? opt.value : null)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label className="small mb-1">Portador</Form.Label>
                <Select
                  isClearable
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={portadoresOptions}
                  placeholder="Todos"
                  noOptionsMessage={() => 'Nenhum portador'}
                  value={portadoresOptions.find((o) => o.value === filtros.codigoPortador) || null}
                  onChange={(opt) => atualizar('codigoPortador', opt ? opt.value : null)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label className="small mb-1">Cedente</Form.Label>
                <Select
                  isClearable
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={cedentesOptions}
                  placeholder="Todos"
                  noOptionsMessage={() => 'Nenhum cedente'}
                  value={cedentesOptions.find((o) => o.value === filtros.codigoCedente) || null}
                  onChange={(opt) => atualizar('codigoCedente', opt ? opt.value : null)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label className="small mb-1">Tipo (multi)</Form.Label>
                <Select
                  isMulti
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={TIPOS_TITULO_BAIXA}
                  placeholder="Todos"
                  noOptionsMessage={() => 'Nenhum tipo'}
                  value={TIPOS_TITULO_BAIXA.filter((t) => (filtros.tipos || []).includes(t.value))}
                  onChange={(opts) => atualizar('tipos', (opts || []).map((o) => o.value))}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6} lg={2}>
              <Form.Group>
                <Form.Label className="small mb-1">Buscar por</Form.Label>
                <Select
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={CAMPOS_BUSCA_RAPIDA}
                  value={CAMPOS_BUSCA_RAPIDA.find((c) => c.value === filtros.campoBuscaRapida)}
                  onChange={(opt) => atualizar('campoBuscaRapida', opt ? opt.value : 'numero')}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label className="small mb-1">Termo da busca rápida</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ex: 12345"
                  value={filtros.buscaRapida}
                  onChange={(e) => atualizar('buscaRapida', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6} lg={8} className="d-flex align-items-end justify-content-end">
              <Button variant="secondary" type="button" onClick={onLimpar} className="mr-2 mb-2">
                <FaEraser className="mr-1" /> Limpar
              </Button>
              <Button variant="primary" type="submit" className="mb-2">
                <FaSearch className="mr-1" /> Pesquisar
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
};

export default CardFiltros;
